// extracted by mini-css-extract-plugin
export default {"root":"QuestionnaireCard_root__5-TOB"};